import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTours, fetchquotelist, fetchdestToursbyDest } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    color: "red",
  },
}));

export default function Thailand() {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const [quotelist, setquotelist] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [listtourData, setlisttourData] =useState([{
    tour_name: "",
    tour_description: "",
    tour_city: "",
    tour_destination: "",
    
    }]);

    useEffect(() => {
        loadtours()
        fetchQuotes()
      }, [])

    const loadtours = async () => {
        const data = await fetchdestToursbyDest("Malaysia");
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisttourData(data.data)
    }
    const fetchQuotes=async()=>{
      const data2 = await fetchquotelist("Malaysia");
      setquotelist(data2.data);
    }
//console.log(listtourData);
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab label="How to Describe" {...a11yProps(0)} />
            <Tab label="Itineraries and Cost" {...a11yProps(1)} />
            <Tab label="Sightseeing Descriptions" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Typography variant="h6" className={classes.input}>
            About Malaysia:
          </Typography>
          <p>
          Malaysia is an amazing country, known for reflecting an eclectic blend of ancient customs, traditions, and culture with a dash of modernity. The country has a lot to offer to its discerning tourists  like beautiful islands, beaches, quaint towns, heritage sites, and adventure spots.
          </p>
          <Typography variant="h6" className={classes.input}>
            Main Attractions:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Top Places:</b> Kuala Lumpur, Penang, Langkawi
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kuala Lumpur:</b> Petronas Tower, KL Tower, Theme Park, Cable Car, Night Life
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Langkawi: </b> Beaches, Island tour, Watersports, Sunset dinner cruise
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Penang: </b> Theme Park, Penang Hills, Buddhist Temple, Beach, 3D Meuseum 
              </ListItemText>
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.input}>
            Traveller type:
          </Typography>
          <p>Couples (P1), Friends (P2), Family (P3), </p>

          <Typography variant="h6" className={classes.input}>
            Duration:{" "}
          </Typography>
          <p>Min. 3 nights. Max. 7 nights</p>
          <Typography variant="h6" className={classes.input}>
            Visa process:{" "}
          </Typography>
          <p>
          Passport copy with 6 month validity till your returning date from Malaysia along with valid Visa
          </p>
          <Typography variant="h6" className={classes.input}>
            Documents for visa:{" "}
          </Typography>
          <p>
          Scanned Passport copies,
Photo – 3.5 MM X 4.5 MM (Soft Copy),
Hotel Voucher,
Air Tickets,
Bank Statement,
Vaccination Proof,
Applicant Contact Number,
Email Id,
Cost is around Rs. 4000 per person


          </p>
          <Typography variant="h6" className={classes.input}>
            How to reach:{" "}
          </Typography>
          <p>
          Flight to Malaysia airport. Direct flights are available to Kuala Lumpur from all major Indian cities as well as other prominent south asian destinations. Flighst area available from Kuala Lumpur to Langkawi and Penang

          </p>
          <Typography variant="h6" className={classes.input}>
            Distance between places:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Airport- Kuala Lumpur:  </b> 60 KM/ Approx 1 hour 
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kuala Lumpur - Penang:  </b> 400 KM/ Approx 5 Hour (Better to travel via Flight)
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kuala Lumpur - Langkawi:  </b> Via Flight 1 Hour
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Penang - Langkawi:  </b> Via ferry 3 Hours  
              </ListItemText>
            </ListItem>
            
          </List>
          <Typography variant="h6" className={classes.input}>
            Can be clubbed with:{" "}
          </Typography>
          <p>Singapore, Thailand & Bali</p>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="h6" className={classes.input}>
            Flight cost: (per person return cost)
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>New Delhi:</b> 25-30k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Mumbai:</b> 24-28k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bengaluru:</b> 20-25k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Hyderabad:</b> 15-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Chennai:</b> 15-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ahmedabad:</b> 25-30k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kolkata:</b> 15-20k
              </ListItemText>
            </ListItem>

          </List>
          <Typography variant="h6" className={classes.input}>
            Common Itineraries: (Cost and Quote Number)
          </Typography>
          <List>
          {quotelist?.map((quote) => {
                return (
                  <div>
                  <ListItem disablePadding>
                  <ListItemText>
                        <b><a href={"/quotedataentry/"+quote.quote_id} target="_blank" rel="noopener noreferrer">{quote.quote_id} - {quote.quote_identifier}</a></b>
                        </ListItemText>
                      </ListItem>
                  </div>
                );
              })}
          </List>
          <Typography variant="h6" className={classes.input}>
            Total Cost: (per person without flights and with visa)
          </Typography>
          <List>
          <ListItem disablePadding>
          <ListItemText>
                <b>4N:</b> 20-25k
              </ListItemText>
          </ListItem>
          <ListItem disablePadding>
          <ListItemText>
                <b>5N:</b> 22-27k
              </ListItemText>
          </ListItem>
          </List>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {listtourData.length>1?(
            listtourData.map(tour =>
                <div>
                <p className={classes.input}>{tour.tour_name} -- Start time:({tour.start_time}) || End time:({tour.end_time})</p>
                    
                    {tour.tour_description}
                    <br></br>
                </div>
            )
          ):("")}
        </TabPanel>
      </Box>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
